<template>
    <div id="slider-category" v-if="categories[data.category_type]">
        <v-container>
            <v-row v-if="data.title">
                <v-col cols="12">
                    <h3 class="text-h3">{{ data.title }}</h3>
                </v-col>
            </v-row>
        </v-container>
        <div class="w-100" v-if="categories[data.category_type].length > 1" :class="data.class">
            <carousel v-bind="slider.settings" :breakpoints="slider.breakpoints" >
                <slide v-for="(category,index) in categories[data['category_type']]" @click="$router.push(category.route)" :key="category.slug+'-'+index" >
                    <v-card 
                        class="w-100 rounded-0 bg-transparent px-2" 
                        @click="$router.push(category.route)">
                        <v-img
                            lazy
                            :gradient="gradient"
                            :lazy-src="category.thumbnail.sizes.thumbnail"
                            :src="category.thumbnail.sizes.full"
                            :alt="category.title+' - '+category.thumbnail.title+' - '+category.thumbnail.description"
                            :aspect-ratio="16/9"
                            cover>
                            <v-container class="fill-height py-0">
                                <v-row no-gutters class="fill-height text-start" align="end">

                                    <v-col cols="12">
                                        <v-btn variant="text" class="btn-primelinks text-start rounded-0" :to="category.route" :title="category.title">
                                            <h2 class="text-start">{{ category.title }}</h2>
                                        </v-btn>
                                    </v-col>

                                </v-row>
                            </v-container>
                        </v-img>
                    </v-card>
                    
                </slide>
                <template #addons>
                        <navigation />
                        <!-- <navigation v-if="data.has_navigation" /> -->
                        <pagination v-if="data.has_pagination" />
                </template>
            </carousel>
        </div>
    </div>
</template>

<script>

import 'vue3-carousel/dist/carousel.css'
import { Carousel, Slide, Navigation, Pagination } from 'vue3-carousel' 
import {mapGetters} from "vuex";

export default{
    props:{
        data:{
            required: true,
            type: Object,
        }
    },
    components: {
        Carousel,
        Slide,
        Navigation,
        Pagination,
    },
    computed: {
        ...mapGetters({
            loading: 'loading/loading',
            categories: 'categories/list',
        }),
    },
    data: () => ({
        gradientColor:{
            black: "to bottom, rgba(0,0,0,1), rgba(0,0,0,0),rgba(0,0,0,0),rgba(0,0,0,0),  rgba(0,0,0,1)",
            white: "to bottom, rgba(255,255,255,1),rgba(255,255,255,0),rgba(255,255,255,0),rgba(255,255,255,0),rgba(255,255,255,1)",
            null: null,
        },
        gradient: null,
        slider:{
            settings:{ 
                "autoplay": 0,
                "pauseAutoplayOnHover": true,
                "snapAlign": "start",
                "wrapAround": false,
            },
            breakpoints:{
                0:{
                    itemsToShow: 1.2,
                },
                768:{
                    itemsToShow: 2.5,
                },
                1280:{
                    itemsToShow: 3.2,
                }
            }
        }
    }),
    mounted(){
        if(this.data.gradient){
            this.gradient = this.gradientColor[this.data.gradient]
        }
        if(!this.categories.length){
            if(this.data.categories){
                this.$store.dispatch('categories/setCategories',this.data.categories)
            }else{
                this.getCategories();
            }
        }
    },
    methods:{
        async getCategories(){
            await this.$store.dispatch('categories/getList');
        }
    }
}
</script>

<style lang="scss">
.carousel {
  --vc-nav-background: #ffffff;
  --vc-nav-color: black;
  --vc-nav-color-hover: #777777;
  --vc-nav-border-radius: 50%;
  --vc-nav-width: 36px;
  --vc-nav-height: 36px;
}
</style>